import { useState, useContext } from 'react';
import { PedidoFiltroContainer, styles, StyledFloatingButton, StyledTable, PedidoContainer, } from './components/PedidosComponents';
import { columns, customStyles, conditionalPedidoRowStyles } from './components/tableOptions';
import Card from '../components/Card/Card';
import CardHeader from '../components/Card/CardHeader';
import CardBody from '../components/Card/CardBody.js';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { FcSearch } from 'react-icons/fc';
import Fab from '@mui/material/Fab';
import ModalPedido from './components/ModalPedido';
import { PedidosContext } from '../context/PedidosContext';
import { AdminContext } from '../context/AdminContext';
import { SNACKBAR_SEVERITY } from '../constants';

import { useEffect } from 'react';
const useStyles = makeStyles(styles);

const PEDIDOS_REFRESH_RATE = 10 * 1000

function Pedidos() {
  const classes = useStyles();

  const { ventas, borrarUnaVenta, obtenerVentaPorId, limpiarVenta, obtenerVentas, obtenerDevoluciones, obtenerProductos, perPage, changeRowsPerPage } = useContext(PedidosContext);
  const { handleClickSnackbar } = useContext(AdminContext);

  //filtro estado
  const [search, setSearch] = useState('');
  //modal
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);

  function buscar(rows) {
    if (rows && rows.length > 0) {
      return rows.filter((row =>
        row.descripcion?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        row.numero?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        row.estado?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1))
    } else return [];
  }

  function toggleModal() {
    setLoading(false);
    limpiarVenta();
    setModal(prev => !prev);
  }

  async function editarVenta(selectedVenta) {
    if (selectedVenta && !loading) {
      setLoading(true);
      const shouldOpenModal = await obtenerVentaPorId(selectedVenta);
      setModal(shouldOpenModal);
    }
  }

  async function deletePedido(_id) {
    const exito = await borrarUnaVenta(_id);
    if (exito) handleClickSnackbar('Pedido Borrado', SNACKBAR_SEVERITY.info);
    else handleClickSnackbar('No se pudo borrar el pedido', SNACKBAR_SEVERITY.error);
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      obtenerVentas();
    }, PEDIDOS_REFRESH_RATE);

    return () => clearInterval(intervalId);
  });

  useEffect(() => {
    obtenerVentas();
    obtenerDevoluciones();
    obtenerProductos();
  }, []);

  return (
    <PedidoContainer>
      <ModalPedido modal={modal} toggleModal={toggleModal} />
      <Card>
        <CardHeader color='primary'>
          <h2 className={classes.cardTitleWhite}>Pedidos</h2>
          <p className={classes.cardCategoryWhite}>
            A continuación se listan los pedidos que aun no fueron entregados
          </p>
        </CardHeader>
        <CardBody>
          <PedidoFiltroContainer>
            <TextField
              variant="standard"
              className={classes.formControl}
              label='Buscar'
              id='Buscar'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                endAdornment: <FcSearch />,
              }} />

          </PedidoFiltroContainer>

          {!loading && <StyledTable
            columns={columns(deletePedido)}
            data={buscar(ventas)}
            customStyles={customStyles}
            conditionalRowStyles={conditionalPedidoRowStyles}
            pagination

            paginationPerPage={perPage}
            onChangeRowsPerPage={(perPage) => changeRowsPerPage(perPage)}
            fixedHeader
            fixedHeaderScrollHeight='600px'
            highlightOnHover
            paginationComponentOptions={
              {
                rowsPerPageText: 'Filas por pagina',
                rangeSeparatorText: 'de',
                selectAllRowsItem: true,
                selectAllRowsItemText: 'Todo'
              }
            }
            responsive={true}
            onRowClicked={(selectedVenta) => editarVenta(selectedVenta._id)}
            noDataComponent={<div>No hay informacion disponible para mostrar</div>} />}
        </CardBody>
      </Card>

      <StyledFloatingButton>
        <Fab
          color='secondary'
          aria-label='add'
          onClick={() => {
            toggleModal();
          }}>
          +
        </Fab>
      </StyledFloatingButton>
    </PedidoContainer>
  );
}

export default Pedidos;
